import { Component, EventEmitter, HostBinding, OnInit, Output, ChangeDetectionStrategy } from '@angular/core'
import { AccountOnboardingCard } from './account-onboarding-card'

@Component({
  selector: 'app-account-onboarding-popup',
  templateUrl: './account-onboarding-popup.html',
  styleUrls: ['./account-onboarding-popup.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AccountOnboardingCardPopup extends AccountOnboardingCard implements OnInit {
  @Output() dismiss = new EventEmitter<void>()
  @HostBinding('style.minWidth.px')
  @HostBinding('style.maxWidth.px')
  @HostBinding('style.width.px')
  get width() {
    return this.isExpanded ? 600 : 400
  }
  isExpanded = false
  currentSection = 0
  totalSections = 0

  ngOnInit(): void {
    super.ngOnInit()
    this.totalSections = this.sections.length
  }

  onDismiss() {
    this.isExpanded = false
    this.dismiss.emit()
  }

  onNext() {
    if (this.currentSection < this.totalSections - 1) {
      this.currentSection++
    }
    this.selectSection(this.sections[this.currentSection])
  }

  onPrevious() {
    if (this.currentSection > 0) {
      this.currentSection--
    }
    this.selectSection(this.sections[this.currentSection])
  }
}
